export default __webpack_public_path__ + "static/media/bottom.efd43880.png";